package com.essntl.features.address.ui

import core.validation.Form
import core.validation.field.Field
import core.validation.field.StringField
import core.validation.validator.NonEmptyValidator

class AddressValidation {
    val addressForm = AddressForm()
}

class AddressForm : Form() {
    val line1 = StringField(NonEmptyValidator)
    val city = StringField(NonEmptyValidator)
    val country = StringField(NonEmptyValidator)

    override val fields: List<Field>
        get() = listOf(line1, city, country)
}